import React from 'react';
import { useLocation } from 'react-router-dom';
import { useDarkMode } from '../../hooks/useDarkMode';
import { isAuthRoute } from '../../config/authAppearance';

export default function ThemeToggle() {
  const { isDark, toggle } = useDarkMode();
  const { pathname } = useLocation();

  const accent = isDark ? '79, 195, 247' : '139, 92, 246';
  const surface = isDark ? 'rgba(30, 39, 46, 0.9)' : 'rgba(255, 255, 255, 0.9)';
  const baseShadow = isDark
    ? `0 8px 32px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(${accent}, 0.1)`
    : `0 8px 32px rgba(${accent}, 0.2), 0 0 0 1px rgba(${accent}, 0.1)`;
  const hoverShadow = `0 16px 48px rgba(${accent}, 0.3), 0 0 0 1px rgba(${accent}, 0.2)`;

  const [isHovered, setIsHovered] = React.useState(false);
  const [isActive, setIsActive] = React.useState(false);

  if (isAuthRoute(pathname)) {
    return null;
  }

  const transform = isActive
    ? 'translateY(-2px) scale(1.05)'
    : isHovered
    ? 'translateY(-4px) scale(1.1)'
    : 'translateY(0) scale(1)';

  const background = isHovered ? `rgba(${accent}, 0.1)` : surface;
  const borderColor = isHovered ? `rgba(${accent}, 0.5)` : `rgba(${accent}, 0.3)`;
  const boxShadow = isHovered ? hoverShadow : baseShadow;

  return (
    <button
      onClick={toggle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
        setIsActive(false);
      }}
      onMouseDown={() => setIsActive(true)}
      onMouseUp={() => setIsActive(false)}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      className="theme-toggle fixed z-[1000] flex items-center justify-center rounded-full border-2 cursor-pointer"
      style={{
        bottom: '24px',
        right: '24px',
        width: '56px',
        height: '56px',
        background,
        borderColor,
        boxShadow,
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        transform,
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
    >
      <span
        style={{
          fontSize: '24px',
          transition: 'transform 0.3s ease',
          transform: isHovered ? 'rotate(180deg) scale(1.1)' : 'rotate(0) scale(1)',
          filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))',
        }}
      >
        {isDark ? '🌙' : '☀️'}
      </span>

      <style>{`
        @media (max-width: 768px) {
          .theme-toggle {
            width: 52px !important;
            height: 52px !important;
            bottom: 20px !important;
            right: 20px !important;
          }
          .theme-toggle > span {
            font-size: 22px !important;
          }
        }
      `}</style>
    </button>
  );
}
